import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarRightHide24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconSidebarRightHide24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M5 5.5h9.5v13H5A1.5 1.5 0 0 1 3.5 17V7A1.5 1.5 0 0 1 5 5.5m14 0h-3v13h3a1.5 1.5 0 0 0 1.5-1.5V7A1.5 1.5 0 0 0 19 5.5M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3zM7.772 9.702a.75.75 0 1 1 1.06-1.06l2.829 2.828.53.53-.53.53-2.828 2.829a.75.75 0 0 1-1.061-1.06L10.07 12z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarRightHide24);
